module.exports = __webpack_public_path__ + "img/vertical-flip.2be56e0a.svg";